import * as z from 'zod'
import { WatchListEntity } from '../WatchListEntity.js'
import { DeleteApiContract, GetApiContract, PostApiContract } from './ApiContract.js'
import { Selectable } from 'kysely'

export interface GetWatchListRequest extends GetApiContract {
    Response: Array<Selectable<WatchListEntity>>
    ResponseJson: Array<Selectable<WatchListEntity>>
}

const entityTypeSchema = z.enum(['Issue', 'Warrant', 'Company', 'Investor', 'Convertible'])

export const postWatchListBodySchema = z.object({
    entityType: entityTypeSchema,
    entityId: z.string(),
})

export interface PostWatchListRequest extends PostApiContract {
    Body: z.infer<typeof postWatchListBodySchema>
    Response: Record<string, never>
    ResponseJson: Record<string, never>
}

export const deleteWatchListQueryParameterSchema = z.object({
    entityType: entityTypeSchema,
    entityId: z.string(),
})

export interface DeleteWatchListItemRequest extends DeleteApiContract {
    Response: Record<string, never>
    ResponseJson: Record<string, never>
    QueryParameters: z.infer<typeof deleteWatchListQueryParameterSchema>
}
